<h1>Authorization code received</h1>
<p>You will be redirected shortly.</p>
